import { render } from "./ConnectionsPopup.vue?vue&type=template&id=6f51117a&scoped=true"
import script from "./ConnectionsPopup.vue?vue&type=script&lang=js"
export * from "./ConnectionsPopup.vue?vue&type=script&lang=js"

import "./ConnectionsPopup.vue?vue&type=style&index=0&id=6f51117a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f51117a"]])

export default __exports__